import { EFavoritesActionTypes } from '../../actions/favorites';
import { EHeaderStateActionType } from '../../actions/headerState';
import { EFavoritesStatus, IFavoritesState } from '../../types/favorites';
import { TReduxActions } from '../../types/redux';

const defaultState: IFavoritesState = {
  count: 0,
  favoriteItems: [],
  status: EFavoritesStatus.Initial,
};

export function favoritesReducer(state: IFavoritesState = defaultState, action: TReduxActions): IFavoritesState {
  switch (action.type) {
    case EHeaderStateActionType.Update:
      return {
        ...state,
        count: action.payload.favorites.count,
      };

    case EFavoritesActionTypes.LoadingUserFavorites:
      return {
        ...state,
        status: EFavoritesStatus.Loading,
        activeRequestId: action.payload.requestId,
      };

    case EFavoritesActionTypes.UpdateUserFavorites:
      if (state.activeRequestId !== action.payload.requestId) {
        return state;
      }

      return {
        ...state,
        favoriteItems: action.payload.favoriteItems,
        status: EFavoritesStatus.Succeed,
        activeRequestId: undefined,
      };

    case EFavoritesActionTypes.FailedUserFavorites:
      if (state.activeRequestId !== action.payload.requestId) {
        return state;
      }

      return {
        ...state,
        status: EFavoritesStatus.Failed,
        activeRequestId: undefined,
      };

    case EFavoritesActionTypes.InvalidateUserFavorites:
      return {
        ...state,
        status: EFavoritesStatus.Initial,
        activeRequestId: undefined,
      };

    case EFavoritesActionTypes.ResetUserFavorites:
      return {
        ...state,
        favoriteItems: [],
        status: EFavoritesStatus.Initial,
        activeRequestId: undefined,
      };

    default:
      return state;
  }
}
